import { render, staticRenderFns } from "./NetlifyIdentityUserModal.vue?vue&type=template&id=7600fea0&"
import script from "./NetlifyIdentityUserModal.vue?vue&type=script&lang=js&"
export * from "./NetlifyIdentityUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports